import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { inputContexts } from 'app/modules/wallforming/components/input-binding/registry/inputActionsRegistry';
import { InputContext } from 'app/modules/wallforming/components/input-binding/types/inputContext';
import { resolveInputContext } from 'app/modules/wallforming/components/input-binding/utils/inputContextUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

/** Scene states used to filter the available bindings. */
export const InputStateMenu = () => {
    const { t } = useTranslation();
    const { filter, setFilter, currentContext } = usePlacementStore(
        useShallow((state) => ({
            filter: state.inputContextFilter,
            setFilter: state.setInputContextFilter,
            currentContext: resolveInputContext(state)
        }))
    );

    return (
        <nav className="flex w-40 shrink-0 flex-col gap-1 border-r border-border-ultra-light bg-background-gray-ultra-light p-1.5">
            {(Object.entries(inputContexts) as [InputContext, (typeof inputContexts)[InputContext]][]).map(
                ([context, { labelKey, icon }]) => (
                    <button
                        key={context}
                        className={`flex w-full cursor-pointer items-center rounded px-1 py-2 text-left text-sm text-text-default hover:bg-background-gray ${
                            filter === context ? 'bg-background-gray' : ''
                        }`}
                        title={context === currentContext ? t('labelInputContextCurrent') : undefined}
                        type="button"
                        onClick={() => setFilter(context)}
                    >
                        <Icon
                            className="action-menu-entry-decoration action-menu-entry-decoration-icon mr-1.5"
                            icon={icon}
                        />
                        <span className="truncate">{t(labelKey)}</span>
                        {context === currentContext && (
                            <span className="ml-auto h-1.5 w-1.5 rounded-full bg-green-500" />
                        )}
                    </button>
                )
            )}
        </nav>
    );
};
